/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import _sliceInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/slice";import isString from"./isString";import isUndefined from"./isUndefined";const insert=function(e,n,i){return isString(e)||(e=`${e}`),(isUndefined(n)||n<0||n>e.length)&&(n=e.length),i=isUndefined(i)?"":i,_sliceInstanceProperty(e).call(e,0,n)+i+_sliceInstanceProperty(e).call(e,n,e.length)};export default insert;